<template>
  <div>J-1-2a__HR_Resume</div>
</template>

<script>
export default {};
</script>

<style></style>
